import { Page } from '@4beefopag/4bee-fopag-core/dist/organisms';
import { useQuery } from '@tanstack/react-query';
import { Empty, Modal, Skeleton } from 'antd';
import moment from 'moment';
import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import * as BenefitOrderRepository from '../../../services/repository/benefitOrderRepository';
import { findAll } from '../../../services/repository/benefitOrderRepository';
import mostrarErro from '../../../services/util/error-handler';
import BenefitOrderListSearchFilters from '../../molecules/BenefitOrderListSearchFilters';
import BenefitOrderListTable from '../../organisms/BenefitOrderListTable';
import ModalApproveReopening from './ModalApproveReopening';
import ModalDenyReopening from './ModalDenyReopening';

const EmptyWrapper = styled.div`
  padding: 50px;
`;

export default function BenefitOrderList() {
  const defaultFilterValues = {
    companies: undefined,
    status: undefined,
    periodStatus: undefined,
    competence: moment(),
    reabertura: undefined,
  };
  const [filtersApplied, setFiltersApplied] = useState(defaultFilterValues);
  const [ordering, setOrdering] = useState({});
  const [pagination, setPagination] = useState({});
  const [currentSort, setCurrentSort] = useState({});
  const [pageSize, setPageSize] = useState(8);
  const [isApproveReopeningModalOpen, setIsApproveReopeningModalOpen] = useState(false);
  const [isDenyReopeningModalOpen, setIsDenyReopeningModalOpen] = useState(false);
  const [selectedOrder, setSelectedOrder] = useState();

  const searchBenefitOrders = async (params) => {
    const data = await findAll({
      ...params,
      competence: params.competence && `${params.competence.format('YYYY-MM-01T00:00:00')}`,
      companies: params.companies && params.companies.join(','),
    });
    return data;
  };

  const unifiedSearchParams = { ...filtersApplied, ...ordering, ...pagination };
  const {
    isPending: loadingBenefitOrders,
    data: benefitOrderData,
    refetch: reloadOrders,
  } = useQuery({
    queryKey: ['benefit-orders', unifiedSearchParams],
    queryFn: () => searchBenefitOrders(unifiedSearchParams),
  });

  const onHandleChangeTable = (currentPagination, filters, sorter) => {
    setCurrentSort({ ...sorter });
    if (sorter?.order) {
      const { order, column } = sorter;
      setOrdering({ sortBy: column.dataIndex, sortType: order });
    }
    if (currentPagination?.current) {
      setPagination({ page: currentPagination.current, limit: pageSize });
    }
  };

  useEffect(() => {
    onHandleChangeTable({ current: 1 }, null, currentSort);
  }, [pageSize]);

  const confirmReopening = async (payload) => {
    try {
      await BenefitOrderRepository.approveReopening(selectedOrder.id, payload);
      await reloadOrders();
      setIsApproveReopeningModalOpen(false);
      Modal.success({
        title: 'Sucesso',
        content: <p>Alteração do período confirmada com sucesso!</p>,
      });
    } catch (err) {
      mostrarErro(err);
    }
  };

  const denyReopening = async (justification) => {
    try {
      await BenefitOrderRepository.denyReopening(selectedOrder.id, justification);
      await reloadOrders();
      setIsDenyReopeningModalOpen(false);
      Modal.success({
        title: 'Sucesso',
        content: <p>Alteração do período reprovada!</p>,
      });
    } catch (err) {
      mostrarErro(err);
    }
  };

  return (
    <Page
      projeto="Benefícios"
      titulo="Consulta de Pedidos"
    >
      <BenefitOrderListSearchFilters
        appliedFilters={filtersApplied}
        onApplyFiltersClick={(updatedFilters) => {
          setPagination({ page: 1, limit: pageSize });
          setFiltersApplied(updatedFilters);
        }}
        onClearFiltersClick={() => setFiltersApplied(defaultFilterValues)}
      />

      <br />

      <Skeleton
        loading={loadingBenefitOrders}
        data-testid="skeleton-operacoes"
      >
        {benefitOrderData?.data && benefitOrderData?.data?.length > 0 ? (
          <BenefitOrderListTable
            benefitOrders={benefitOrderData.data}
            onHandleChange={onHandleChangeTable}
            paginationData={{
              total: benefitOrderData.totalItems,
              pageSize,
              currentPage: benefitOrderData.currentPage,
              updatePageSize: (value) => setPageSize(value),
            }}
            currentSort={currentSort}
            reloadOrders={reloadOrders}
            onApproveReopeningClick={(order) => {
              setIsApproveReopeningModalOpen(true);
              setSelectedOrder(order);
            }}
            onDenyReopeningClick={(order) => {
              setIsDenyReopeningModalOpen(true);
              setSelectedOrder(order);
            }}
          />
        ) : (
          <EmptyWrapper>
            <Empty description="Nenhum pedido encontrado" />
          </EmptyWrapper>
        )}
      </Skeleton>
      <ModalApproveReopening
        open={isApproveReopeningModalOpen}
        onCancelClick={() => setIsApproveReopeningModalOpen(false)}
        onConfirmClick={confirmReopening}
        benefitOrder={selectedOrder}
      />
      <ModalDenyReopening
        open={isDenyReopeningModalOpen}
        onCancelClick={() => setIsDenyReopeningModalOpen(false)}
        onConfirmClick={denyReopening}
        benefitOrder={selectedOrder}
      />
    </Page>
  );
}
